import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { AnalyticsResultsService, IncomeVsSpendStatistic } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-income-and-expenses-line-chart',
  templateUrl: './income-and-expenses-line-chart.component.html',
  styleUrls: ['../widgets.scss', './income-and-expenses-line-chart.component.scss']
})
export class IncomeAndExpensesLineChartComponent implements OnInit {
  incomeVsExpenseData: IncomeVsSpendStatistic[] = new Array<IncomeVsSpendStatistic>();
  incomeVsExpenseLoading: boolean = true;
  incomeVsExpenseNotFound: boolean = false;

  constructor(private resultsAnalyticsSvc: AnalyticsResultsService, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      if (this.chartOptions && this.chartOptions.scales && this.chartOptions.scales["x"]) {
        this.chartOptions.scales["x"].display = (this.isMobile === false);
        this.chart?.render();
      }
    });
  }

  isMobile: boolean = false;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  chartPlugins = [];

  chartData: ChartData<'line', number[], Date> = {
    labels: [],
    datasets: [{
      label: "Expenses",
      fill: true,
      data: []
    }, {
      label: "Income",
      fill: true,
      data: []
    }]
  };

  chartOptions: ChartConfiguration['options'] = {
    // We use these empty structures as placeholders for dynamic theming.
    elements: {
      line: {
        tension: 0.25,
      },
      point: {
        hitRadius: 10,
        radius: 0
      }
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: 'month',
          tooltipFormat: 'MMM yy'
        },
        grid: {
          display: false
        },
        title: {
          display: false,
          text: 'Balance Date'
        }
      },
      y: {
        beginAtZero: true,
        display: true,
        grid: {
          display: false
        },
        position: "right",
        ticks: {
          callback: (value, index, ticks) => {
            let v = value as number;
            if (v) {
              return '$' + v.toLocaleString();
            }
            return '$' + value;
          }
        }
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (item) =>
            `$${item.formattedValue}`
        }
      }
    },
  };

  ngOnInit(): void {
    this.loadIncomeVsExpenseData();
  }

  loadIncomeVsExpenseData() {
    this.resultsAnalyticsSvc.getIncomeVsSpendStatistics()
      .subscribe({
        next: (data: IncomeVsSpendStatistic[]) => {
          this.incomeVsExpenseData = data;
          this.incomeVsExpenseLoading = false;
          this.buildIncomeVsExpenseChartData();
        },
        error: (err: HttpErrorResponse) => {
          this.incomeVsExpenseNotFound = true;
          this.incomeVsExpenseLoading = false;
          console.log("error loading income vs expense statistics");
          console.log(err);
        }
      });
  }

  buildIncomeVsExpenseChartData() {
    let labels = new Array<Date>();
    let incomeData = new Array<number>();
    let expenseData = new Array<number>();

    if (this.incomeVsExpenseData && this.incomeVsExpenseData.length > 0) {
      this.incomeVsExpenseData.forEach((x) => {
        labels.push(x.dim_txndate_yearmonth_date);

        if (x.fct_income !== undefined) {
          incomeData.push(x.fct_income);
        } else {
          incomeData.push(0);
        }

        if (x.fct_spend !== undefined) {
          expenseData.push(Math.abs(x.fct_spend));
        } else {
          expenseData.push(0);
        }
      });
    }

    if (labels.length > 12) {
      let itemsToRemove = labels.length - 12;
      labels.splice(0, itemsToRemove);
      incomeData.splice(0, itemsToRemove);
      expenseData.splice(0, itemsToRemove);
    }

    this.chartData.labels = labels;
    this.chartData.datasets[0].data = expenseData;
    this.chartData.datasets[1].data = incomeData;

    this.chart?.update();
  }


}

